angular.module( 'acme.view.application.coupons.create.detail', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.coupons.create.detail.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var couponsCreateDetail = {
        name: 'application.coupons.create.detail',
        url: '/detail',
        views: {
          "subview-main": {
            controller: 'CouponsCreateDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/coupons/create/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: 'Coupon Details',
          /** Secure With Roles **/
          permissions: ['COUPONS_VIEW']
        }
      };

    $stateProvider
      .state(couponsCreateDetail);
});
